import React, { Component, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Container } from 'reactstrap'
import { AppFooter, AppHeader, AppSidebar, AppSidebarFooter, AppSidebarNav, } from '@coreui/react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import routes from '../routes'
import Loader from '../components/Common/Loader'
import SelectPicker, { IconOption } from '../components/Common/SelectPicker'
import { loadLocale, setCountry, setLanguage } from '../actions/locale'
import { selectCountries, selectSidebarMenu, selectSosNumbers, selectUpcomingHoliday } from '../utils/selectors/locale'
import Breadcrumbs from '../components/Breadcrumbs'
import { __ } from '../services/translate'
import Footer from '../components/Footer'
import HolidayNotice from '../components/Holidays/HolidayNotice'
import { loadContent } from '../actions/content'
import SearchInput  from './SearchInput'
import { MobileOnly } from '../components/Common/Screen'
import { setVehicle } from '../actions/user'

const Header = React.lazy(() => import('./Header'))
const SosHelp = React.lazy(() => import('../components/SosHelp'))

class Layout extends Component {
  componentDidMount() {
    this.props.loadContent()
    this.props.loadLocale()
  }

  render() {
    if (this.props.loading) {
      return <Loader/>
    }

    return (
      <div className="app">
        <AppHeader fixed>
          <Suspense fallback={<Loader/>}>
            <Header/>
          </Suspense>
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <MobileOnly>
              <SearchInput/>
              <PickerContainer>
                <span>{__('Mé vozidlo')}:</span>
                <SelectPicker
                  renderOption={vehicle => __(vehicle.name)}
                  selected={this.props.selectedVehicleType}
                  onSelect={vehicle => this.props.setVehicle(vehicle.id)}
                  options={this.props.vehicles}
                />
              </PickerContainer>
              <PickerContainer>
                <span>{__('Jazyk aplikace')}:</span>
                <SelectPicker
                  renderOption={language => language.name}
                  selected={this.props.selectedLanguageId}
                  onSelect={language => this.props.setLanguage(language)}
                  options={this.props.languages}
                />
              </PickerContainer>
            </MobileOnly>
            <Suspense>
              <AppSidebarNav navConfig={{ items: this.props.menu }}/>
            </Suspense>
            <AppSidebarFooter/>
            <CountryPickContainer>
              <CountryPickerLabel>{__('Zobrazováni obsahu pro krajinu')}:</CountryPickerLabel>
              <SelectPicker
                renderOption={country => <IconOption icon={country.icon} value={country.name}/>}
                selected={this.props.selectedCountryId}
                onSelect={country => this.props.setCountry(country.id)}
                options={this.props.countries}
              />
            </CountryPickContainer>
          </AppSidebar>
          <main className="main">
            {this.props.holiday.length > 0 && <HolidayNotice>{this.props.holiday.map((holiday, i) => <div key={i}>{holiday}</div>)}</HolidayNotice>}
            <Breadcrumbs/>
            <Container fluid>
              <Suspense fallback={<Loader/>}>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => (
                          <route.component {...props} />
                        )}/>
                    ) : (null)
                  })}
                </Switch>
              </Suspense>
            </Container>
          </main>
        </div>
        <AppFooter>
          <Footer/>
          <Suspense fallback={<Loader/>}>
            <SosHelp numbers={this.props.numbers}/>
          </Suspense>
        </AppFooter>
      </div>
    )
  }
}

const CountryPickerLabel = styled.div`
  margin-left: .3rem;
  margin-bottom: -.8rem;
`

const CountryPickContainer = styled.div`
  margin: 0 1rem;
`

const PickerContainer = styled.div`
  span {
    display: block;
    margin: .5rem 0 -1rem;
  }
`

const mapStateToProps = (state) => ({
  countries: selectCountries(state.locale),
  languages: state.locale.languages,
  vehicles: state.user.vehicleTypes,
  numbers: selectSosNumbers(state.locale),
  selectedCountryId: state.locale.selectedCountry,
  selectedVehicleType: state.user.selectedVehicleType,
  selectedLanguageId: state.locale.selectedLanguage.id,
  menu: selectSidebarMenu(state),
  holiday: selectUpcomingHoliday(state),
  loading: state.content.loading
})

const mapDispatchToProps = (dispatch) => ({
  setCountry: (country) => dispatch(setCountry(country)),
  setLanguage: (language) => dispatch(setLanguage(language)),
  setVehicle: (vehicle) => dispatch(setVehicle(vehicle)),
  loadLocale: () => dispatch(loadLocale()),
  loadContent: () => dispatch(loadContent()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
